import React, { useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { taskByAssignedToByStatusByDueDate } from "../../../graphql/queries";
import { deleteUser, deleteTask } from "../../../graphql/mutations";
import { updateUserMini } from "../../../graphql/reloadyard/custom-mutations";

import { Button, Confirm, useNotify, useRedirect } from "react-admin";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { UserType, UserStatus } from "../../../utils/constants";
import { emailAccountDeletionHTML } from "./emailAccountDeletionHTML";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({ record, className, ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const isDeleteDisabled = () => {
    return (
      loading ||
      window.appUser?.id === record?.id ||
      window.appUser?.type === UserType.CREW ||
      (window.appUser?.type === UserType.SUPERVISOR &&
        record.type === UserType.MANAGER)
    );
  };

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setLoading(true);
    try {
      debugger;
      if (
        record.status === UserStatus.NEW ||
        record.status === UserStatus.PENDING_REG
      ) {
        // Delete assigned Tasks
        let response = await API.graphql(
          graphqlOperation(taskByAssignedToByStatusByDueDate, {
            assignedTo: record.id,
          }),
        );
        const tasks = response.data.taskByAssignedToByStatusByDueDate.items;
        await Promise.all(
          tasks.map((task) => {
            return API.graphql(
              graphqlOperation(deleteTask, { input: { id: task.id } }),
            );
          }),
        );

        await API.graphql(
          graphqlOperation(deleteUser, { input: { id: record.id } }),
        );
      } else {
        // Update user active = false, tirggers lambda function "aws/lambda/UpdateCognito"
        let userToUpdate = record;
        userToUpdate.active = "false";
        delete userToUpdate.createdAt;
        delete userToUpdate.updatedAt;
        await API.graphql(
          graphqlOperation(updateUserMini, { input: userToUpdate }),
        );
      }
      const emailContent = emailAccountDeletionHTML(
        record.firstName,
        window.appUser?.firstName,
        window.appUser?.reloadYard.name,
      );

      const emailSubject = "Your transloads.co account has been deleted!";

      try {
        const response = await API.post("transREST", "/sendEmail", {
          body: {
            to: record.email,
            bcc: ["support@transloads.co"],
            subject: emailSubject,
            template: "emailTemplate.html",
            htmlContent: emailContent,
          },
        });

        if (response.error) {
          throw response.error;
        } else {
          notify(`User created successfully.`);
          redirect("/users");
        }
      } catch (error) {
        logError("users:UserEmailError", error, false);
      }
      notify("User deleted successfully", "success");
      redirect("/users");
    } catch (error) {
      logError("users:DeepDeleteButton:handleDelete", error, notify);
    }

    setLoading(false);
    setOpen(false);
  };

  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={isDeleteDisabled()}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={loading}
        title={"Delete Confirmation"}
        content={"Are you sure you want to delete this User?"}
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
